<template>
  <div class="gathering2">
    <p class="gathering2__desc">Det andra steget är att samla ihop övriga tillgångar och skulder.</p>

    <div class="gathering2__container">
      <section class="gathering2__left">
        <h3 class="gathering2__container-title">Tillgångar</h3>
        <SettingsItem v-for="(data, i) in assetsData" :key="i" :setting="data"/>
      </section>

      <section class="gathering2__right">
        <h3 class="gathering2__container-title">Skulder</h3>
        <SettingsItem v-for="(data, i) in debtData" :key="i" :setting="data"/>
      </section>
    </div>

    <form>
      <input
        class="gathering2__form-submit"
        type="submit"
        name="submit"
        id="submit"
        value="ta dig vidare till Nästa steg"
        v-on:click="done($event)"
      />
    </form>
  </div>
</template>

<script>
import SettingsItem from '../../../settings/SettingsItem.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'GatheringStep2',
  components: { SettingsItem },
  methods: {
    done (event) {
      this.$emit('clicked', event);
    }
  },
  computed: {
    ...mapGetters([ 'user' ]),
    assetsData () {
      let access = this.user.access;

      return ([
        {
          'field': "realEstate",
          "firstValue": access.realEstate.value,
          "secondValue": access.realEstate.increaseInValue,
          "labelOne": "Fastighetsvärdering",
          "labelTwo": "Beräknad årlig värdeökning"
        },
        {
          "field": "vehicle",
          "firstValue": access.vehicle.value,
          "secondValue": access.vehicle.increaseInValue,
          "labelOne": "Bilar och motorcyklar",
          "labelTwo": "Beräknad årlig värdeförändring"
        },
        {
          "field": "boat",
          "firstValue": access.boat.value,
          "secondValue": access.boat.increaseInValue,
          "labelOne": "Sjöfordon",
          "labelTwo": "Beräknad årlig värdeförändring"
        },
        {
          "field": "other",
          "firstValue": access.other.value,
          "secondValue": access.other.increaseInValue,
          "labelOne": "Konst och värdeföremål",
          "labelTwo": "Beräknad årlig värdeförändring"
        },
      ])
    },
    debtData () {
      let access = this.user.access;

      return ([
        {
          "field": "loan",
          "firstValue": access.loan.value,
          "secondValue": access.loan.increaseInValue,
          "labelOne": "Lån (din del)",
          "labelTwo": "Ränta"
        },
      ])
    }
  },
}
</script>

<style lang="scss" scoped>
.gathering2 {
  &__desc {
    margin: 2rem 0;
  }

  &__container {
    display: flex;
    flex-direction: column;

    &-title {
      font-size: 20px;
      text-transform: none;
      color: $mainTextColor;
    }

    @include breakpoints(medium) {
      flex-direction: row;
      justify-content: space-between;
    }
  }

  &__left, &__right {
    width: 100%;

    @include breakpoints(medium) {
      width: 45%;
    }
  }

  &__right {
    h3 {
      margin-top: 2rem;

      @include breakpoints(medium) {
        margin-top: 0;
      }
    }
  }

  &__form {
    &-submit {
      width: 100%;
      border-radius: 1.5em;
      border: none;
      cursor: pointer;
      font-size: 1rem;
      text-transform: uppercase;
      font-family: "Roboto", sans-serif;
      font-weight: bold;
      transition: all .5s;
      padding: 13px 25px;
      margin-top: 2rem;
      color: $white;
      background-color: $mediumGreen;

      &:hover {
        background-color: $lightGreen;
      }
    }
  }
}
</style>